import { defineMessages } from 'react-intl';

export const messages: {
	'atlassian-web-crawler': {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	['atlassian-web-crawler']: {
		id: 'search-page.products.custom-website',
		defaultMessage: 'Web page',
		description:
			'Singular noun label for a web page result type, shown in the search page to identify content indexed from a custom website.',
	},
});
